import { render, staticRenderFns } from "./matching-list-cards.vue?vue&type=template&id=3a660e4d&scoped=true&"
import script from "./matching-list-cards.vue?vue&type=script&lang=ts&"
export * from "./matching-list-cards.vue?vue&type=script&lang=ts&"
import style0 from "./matching-list-cards.vue?vue&type=style&index=0&id=3a660e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a660e4d",
  null
  
)

export default component.exports